import { render, staticRenderFns } from "./DesignationList.vue?vue&type=template&id=dc1fd390&"
import script from "./DesignationList.vue?vue&type=script&lang=js&"
export * from "./DesignationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports